export enum DocumentType {
  OtherLegalEntityMinistryConsent = 1,
  OtherLegalEntityProgramExecutionRequest = 2,
  ProgramExecutionResolution = 3,
  AgencyExpertOpinion = 4,
  DocumentCourtRegister = 5,
  DocumentFoundingAct = 6,
  MinimumRequirementSolution = 7,
  LocationMinimumRequirementSolution = 8,
  LocationUsageAgreement = 9,
  CurriculumProgram = 10,
  UsageAgreement = 11,
  TeacherAdditional = 12,
  TeacherDiploma = 13,
  TeacherStatement = 14,
  TeacherLanguageCertification = 15,
  CopyOfDiploma = 16,
  AdditionalDocument = 17,
  OtherLegalEntityPersonnelConditions = 18,
  AdditionalDocumentation = 19,
  NotificationAttachment = 20,  
}